import { Hero } from "@/components/Hero";
import { Partners } from "@/components/Partners";
import { HowItWorks } from "@/components/HowItWorks";
import { Features } from "@/components/Features";
import { Testimonials } from "@/components/Testimonials";
import { CTA } from "@/components/CTA";
import { FAQ } from "@/components/FAQ";

export default function Home() {
  return (
    <>
      <Hero />
      <Partners />
      <HowItWorks />
      <Features />
      <Testimonials />
      <CTA />
      <FAQ />
    </>
  );
}
